import { toKebabCase } from './strings.js';

/**
 * Returns a partial copy of an object containing only the keys specified
 * @param {array} names
 * @param {object} obj
 * @returns {object}
 */

function pick(names, obj) {
  var result = {};

  if (obj !== null && typeof obj === "object") {
    for (var i = 0; i < names.length; i++) {
      if (obj.hasOwnProperty(names[i]) && obj[names[i]] !== null && obj[names[i]] !== undefined) {
        result[names[i]] = obj[names[i]];
      }
    }
  }

  return result;
}
/**
 * Returns an array of translation keys
 * @param {object} errors
 * @returns {array} translationKeys
 */

function normalizeFieldErrors(errors) {
  if (!errors || typeof errors != "object" || !Object.getPrototypeOf(errors).isPrototypeOf(Object)) {
    return [];
  }

  var errorTranslationKeys = [];
  Object.keys(errors).forEach(key => {
    var reason = errors[key][0] || "";
    var translationKey = "".concat(toKebabCase(key), ".").concat(toKebabCase(reason));
    errorTranslationKeys.push(translationKey);
  });
  return errorTranslationKeys;
}

export { normalizeFieldErrors, pick };
